import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["flush", "scrollable", "title", "titleSize", "titleTagName", "toolbar", "onExpandedChange", "expanded"];
import { toShorthandSize } from '../../utils/tShirtSizes';
import { Text } from '../../../components/Text/Text';
import { Flex } from '../../../components/Flex/Flex';
import { filterProps } from '../../../utils/filterProps';
import { useMapStylePropsToCSS } from '../../../hooks/useMapStylePropsToCSS';
import styled from 'styled-components';
import { AccordionItem } from '../AccordionItem/AccordionItem';
import { sizeToHeading } from '../AccordionItem/AccordionItem.helpers';
import { useCardContext } from './CardContext';
import { StyledCardSection } from './CardSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Toolbar = styled.div.withConfig({
  displayName: "CardHeader__Toolbar",
  componentId: "sc-1gqv7qj-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    flex: '1 0 auto',
    textAlign: 'right',
    marginLeft: theme.space['300']
  };
});
const StyledHeader = styled.div.withConfig({
  displayName: "CardHeader__StyledHeader",
  componentId: "sc-1gqv7qj-1"
})(({
  $flush,
  $compact,
  $cssStyles,
  theme: _theme
}) => {
  const theme = _theme;
  const spacing = $compact ? theme.space['600'] : theme.space['1000'];
  const paddingX = $flush ? '0' : spacing;
  const padding = `${spacing} ${paddingX} ${spacing}`;
  return Object.assign({
    padding,
    borderRadius: 'inherit',
    [`& + ${StyledCardSection}`]: {
      paddingTop: 0
    }
  }, $cssStyles);
});
export const CardHeader = _ref => {
  let {
      flush = false,
      scrollable = false,
      title,
      titleSize = 'md',
      titleTagName,
      toolbar,
      onExpandedChange,
      expanded: propExpanded = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    styleProps
  } = filterProps(rest);
  const cssStyles = useMapStylePropsToCSS(styleProps);
  const {
    compact,
    expandable,
    expanded,
    onToggle
  } = useCardContext();
  const shorthandSize = toShorthandSize(titleSize);
  const isExpanded = propExpanded && expanded;
  const onCardToggle = () => {
    onToggle();
    onExpandedChange === null || onExpandedChange === void 0 || onExpandedChange();
  };
  return /*#__PURE__*/_jsx(StyledHeader, Object.assign({}, domProps, {
    $flush: flush,
    $scrollable: scrollable,
    $compact: compact,
    $cssStyles: cssStyles,
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "start",
      justifyContent: "space-between",
      children: [expandable || onExpandedChange ? /*#__PURE__*/_jsx(AccordionItem, {
        flush: true,
        isCardHeader: true,
        onOpenChange: onCardToggle,
        open: isExpanded,
        title: title,
        size: shorthandSize,
        titleTagName: titleTagName
      }) : /*#__PURE__*/_jsx(Text, {
        as: titleTagName || sizeToHeading[shorthandSize],
        children: title
      }), toolbar && isExpanded ? /*#__PURE__*/_jsx(Toolbar, {
        children: toolbar
      }) : null]
    })
  }));
};